/* eslint-disable no-underscore-dangle */
import * as React from 'react';
import { useSanityNewsByUrlId } from '../../../../../../../../../../../../../../../../sanity';
import { LatestNews } from './components';

export const LeftMenuNewsMapper = () => {
  const {
    data,
  } = useSanityNewsByUrlId();
  return data != null
    ? (
      <div>
        {data.latestNews.map((news) => (
          <LatestNews key={news._id} id={news._id} />
        ))}
      </div>
    )
    : null;
};
